import { useEffect } from 'react'

const usePreventPullToRefresh = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return

    const preventPullToRefreshIfAtTop = (e) => {
      const { target } = e
      const isScrollable =
        target.scrollHeight > target.clientHeight ||
        document.scrollingElement.scrollTop > 0

      const isTouchingTop =
        (target === document.body || target === document.documentElement) &&
        window.scrollY === 0

      const isSwipeDown = e.touches?.[0]?.clientY > 0

      if (!isScrollable && isTouchingTop && isSwipeDown) {
        e.preventDefault()
      }
    }

    document.addEventListener('touchmove', preventPullToRefreshIfAtTop, {
      passive: false,
    })

    return () => {
      document.removeEventListener('touchmove', preventPullToRefreshIfAtTop)
    }
  }, [enabled])
}

export default usePreventPullToRefresh
